module.exports = __webpack_public_path__ + "img/landing-logo.30ec6994.png";